module.exports = __webpack_public_path__ + "static/media/pcm_login_background.7b866a7b.png";